import numberFormat from "./numberFormat.filter";

const denomFormat = (value, format = "0,0.000000", minimumDecimals = 2) => {
  if (value === NaN) return 0;
  if (Number(value) === Infinity) return value;
  let output = numberFormat(value, format, true, false);
  const [intPart, decimalPart = ""] = output.split(".");
  return `${intPart}.${decimalPart.padEnd(minimumDecimals, "0")}`;
};

export default denomFormat;
